import type {
  AnalyticsEvent,
  AnalyticsIdentifyPayload,
} from "@repo/analytics/client";
import { createContext, useContext } from "react";

export type AnalyticsContext = {
  identify(
    distinctId: string,
    properties?: AnalyticsIdentifyPayload,
  ): Promise<void>;
  unidentify(): Promise<void>;
  trackEvent(event: AnalyticsEvent): Promise<void>;
  trackPageView(url: string): Promise<void>;
};

export const analyticsContext = createContext<AnalyticsContext>({
  identify: async () => void 0,
  unidentify: async () => void 0,
  trackEvent: async () => void 0,
  trackPageView: async () => void 0,
});

export function useAnalytics() {
  const context = useContext(analyticsContext);
  return context;
}
